import { render, staticRenderFns } from "./BasalamCategories.vue?vue&type=template&id=faa0bb0e&scoped=true"
import script from "./BasalamCategories.vue?vue&type=script&lang=js"
export * from "./BasalamCategories.vue?vue&type=script&lang=js"
import style0 from "./BasalamCategories.vue?vue&type=style&index=0&id=faa0bb0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faa0bb0e",
  null
  
)

export default component.exports